import { render, staticRenderFns } from "./Atendimentos.vue?vue&type=template&id=f54dad74&scoped=true"
import script from "./Atendimentos.vue?vue&type=script&lang=js"
export * from "./Atendimentos.vue?vue&type=script&lang=js"
import style0 from "./Atendimentos.vue?vue&type=style&index=0&id=f54dad74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54dad74",
  null
  
)

export default component.exports